module.exports = __webpack_public_path__ + "static/email2-507a3d58d1bca460329d28e775f6ed9a.gif";